var __rspack_ns_object = JSON.parse('{"TITLE":"Finance","TABS":{"OVERVIEW":"Overview","DEPOSITS":"Deposits"}}')